import type { AdditionalData, IngressRequest } from '@dispatch/shared/types';

import { buildSupplementalDataFromAdditionalData } from './buildSupplementalDataFromAdditionalData';

export function applyAdditionalDataToIngressRequest(
  request: IngressRequest,
  data: AdditionalData | undefined
): IngressRequest {
  const { claim, assignmentHandling } = request.$msg;
  const supplementalData = buildSupplementalDataFromAdditionalData(data);

  return {
    ...request,
    $msg: {
      ...request.$msg,
      claim:
        supplementalData.length > 0 ? { ...claim, supplementalData } : claim,
      // Notes are the adjuster's free text only; an empty entry is still sent
      // as '' so the payload shape does not change.
      assignmentHandling: {
        ...assignmentHandling,
        notes: assignmentHandling.notes || '',
      },
    },
  };
}
